// extracted by mini-css-extract-plugin
export var subtitle = "_ca-2";
export var title = "_ca-0";
export var titleNoWrap = "_ca-1";